import {
  ArrowRightOutlined,
  ColumnWidthOutlined,
  InfoCircleOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { Card, Form, Input, MenuProps, Popconfirm, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'app/hooks';
import { useDispatch } from 'react-redux';
import './indexAddEditWL.css';

import { List } from 'antd';
import MenuItem from 'antd/lib/menu/MenuItem';
import ITVSelect from 'components/ITVSelect';
import { getCategoryWithType } from 'features/configuration/categoryAction';
import {
  DotColorStyled,
  ItemColorStyled,
  SelectOptionStyled,
  SelectStyled,
} from 'features/configuration/components/LeaveOffItem/styled';
import { selectConfiguration } from 'features/configuration/configurationSlice';
import { selectDepartment } from 'features/department/departmentSlice';
import { filterSortEmployeeList, getEmployeeDetail } from 'features/employee/employeeAction';
import { actions, selectEmployee, selectEmployeeList } from 'features/employee/employeeSlice';
import { IEmployee, IEmployeeDetail } from 'hrm-common/extensions/interfaces/personel';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import CustomButton from 'styles/buttonStyled';
import { capitalizeFirstLetter, removeAccents } from 'utils/text';
import { CustomCard, CustomFormItem, CustomMenu, CustomTag } from '../styled';
import EmployeeColumn from './EmployeeColumn';
import ITVSelectDepartment from './ITVSelectDepartment';

const { Option } = Select;

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group',
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

const ModalNode = (props: any) => {
  const {
    form,
    edgenextValueNode,
    edgePrevValueNode,
    valueNode,
    initialEdges,
    nodes,
    loadMoreData,
    selectStatus,
    openKeys,
    setOpenKeys,
    errMessageStatusNode,
    setErrMessageStatusNode,
    errMessageDesNode,
    setErrMessageDesNode,
  } = props;
  const { t } = useTranslation([
    'validation',
    'overtime',
    'action',
    'onboard',
    'validation',
    'timesheet',
  ]);
  const dataStore = useAppSelector(selectConfiguration);
  const [, setDataEmployee] = useState([]);
  const [colorNode, setColorNode] = useState('red');
  const [dataSelecListEmployee, setDataSelecListEmployee] = useState([]);
  const [, setDataListIdEmployee] = useState([]);
  const [, setLoadingData] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const arrEmployee = nodes?.find((item: any, idx: any) => {
      return valueNode?.id === item?.id;
    })?.data?.employee;
    setDataEmployee(arrEmployee);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueNode]);

  const dataDepartment = useAppSelector(selectDepartment);
  const dataFindOneStatus = selectStatus !== undefined ? dataStore?.dataGroupStatus : [];
  const employeeList: IEmployeeDetail[] = useAppSelector(selectEmployeeList);
  const employee: IEmployee = useAppSelector(selectEmployee);
  const { resetStateEmployee, resetStateEmployeeList } = actions;
  const [arrColor, setArrColor] = useState([]);

  useEffect(() => {
    let status = nodes?.find((item: any) => {
      return item?.id === valueNode?.id;
    });
    let employees = nodes?.find((item: any) => {
      return item?.id === valueNode?.id;
    })?.data?.employees;
    setDataSelecListEmployee(employees || []);
    form.setFieldsValue({
      status: status?.data?.status,
      listEmployee: employees,
    });
    form.resetFields(['listDepartment', 'employeeId']);

    dispatch(resetStateEmployeeList({}));
    return () => {
      dispatch(resetStateEmployee({}));
      dispatch(resetStateEmployeeList({}));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueNode]);

  const handleSelectDepartment = (departmentId) => {
    if (departmentId !== 'All') {
      dispatch(
        filterSortEmployeeList({
          filter: {
            departmentName: [departmentId],
          },
        }),
      );
    } else {
      dispatch(
        filterSortEmployeeList({
          filter: {
            departmentName: [],
          },
        }),
      );
    }
    setLoadingData(true);
    form.setFieldsValue({ departmentId, employeeId: undefined });
    // await (onChangeEmployeeId && onChangeEmployeeId(employeeId));
    setLoadingData(false);
  };

  const onAddEmployee = () => {
    if (!_.isEmpty(employee?.employeeDetail)) {
      let newList = dataSelecListEmployee?.concat(employee?.employeeDetail);
      let uniq = Object.values(
        newList?.reduce((acc, cur) => Object.assign(acc, { [cur?.id]: cur }), {}),
      );

      const listIdEmployee = uniq?.map((item: any) => {
        return item?.id;
      });
      setDataSelecListEmployee(uniq); //To view screen
      setDataListIdEmployee(listIdEmployee); //To send BE
      form.setFieldsValue({ employeeId: undefined });
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      listEmployee: dataSelecListEmployee, //send BE
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSelecListEmployee]);

  const onDeleteEmployee = (id: any) => {
    let newList = dataSelecListEmployee.filter(function (item) {
      return item.id !== id?.id;
    });
    setDataSelecListEmployee(newList); //To view screen
    // setDataListIdEmployee(listIdEmployee); //To send BE
  };

  useEffect(() => {
    dispatch(
      getCategoryWithType({
        typeConfig: 'color',
        callBack: (response: any) => {
          if (!response?.error && response?.statusCode === 200) {
            setArrColor(response?.data?.value);
          }
        },
      }),
    );
  }, [dispatch]);

  const [, setValueStatusNode] = useState('');

  const handleSelectStatusNode = (value) => {
    let checkDuplicateStatusNode = nodes
      ?.filter((item) => item?.id !== valueNode?.id)
      ?.find((item: any) => {
        return item?.data?.status === value;
      });

    if (!checkDuplicateStatusNode) {
      setValueStatusNode(value);
      setErrMessageStatusNode(undefined);
    } else {
      setErrMessageStatusNode(checkDuplicateStatusNode);
    }
  };
  const handleDescriptionNode = (value) => {
    let checkDuplicateDescriptionNode = nodes
      ?.filter((item) => item?.id !== valueNode?.id)
      ?.find((item: any) => {
        return item?.data?.label.trim() === value.trim();
      });

    if (!checkDuplicateDescriptionNode) {
      setValueStatusNode(value);
      setErrMessageDesNode(undefined);
    } else {
      setErrMessageDesNode(checkDuplicateDescriptionNode);
    }
  };
  const items: MenuItem[] = [
    getItem('Info Process', 'sub0', <InfoCircleOutlined />, [
      getItem(
        <Card style={{ marginBottom: '30px' }}>
          <Form.Item name={'colorNode'} label={<div>Color Process</div>}>
            <SelectStyled
              placeholder={'Please select color'}
              value={colorNode}
              onChange={(value: any) => {
                setColorNode(value);
              }}
            >
              {arrColor.map((item: any) => {
                return (
                  <SelectOptionStyled
                    key={item.id}
                    value={item.code}
                    // label={capitalizeFirstLetter(item.name)}
                  >
                    <ItemColorStyled>
                      <DotColorStyled
                        style={{
                          backgroundColor: item.code,
                        }}
                      />
                      {capitalizeFirstLetter(item.name)}
                    </ItemColorStyled>
                  </SelectOptionStyled>
                );
              })}{' '}
            </SelectStyled>
          </Form.Item>

          <Form.Item
            name={'desValue'}
            label={<div>Description</div>}
            rules={[
              {
                required: true,
                message: t('HRM_VAD_REQUIRED', { field: 'Description' }),
              },
              {
                whitespace: true,
                message: t('HRM_VAD_BLANK_CHARACTERS', { field: 'Description' }),
              },
            ]}
            style={{ marginBottom: errMessageDesNode ? '0px' : '30px' }}
          >
            <Input
              placeholder={'Please input description'}
              maxLength={255}
              onChange={(e: any) => handleDescriptionNode(e.target.value)}
            />
          </Form.Item>
          {errMessageDesNode && <p style={{ color: 'red' }}>Description is duplicate</p>}

          {valueNode?.id !== '1' && (
            <>
              <Form.Item
                name="status"
                rules={[
                  {
                    required: true,
                    message: t('HRM_VAD_REQUIRED', { field: 'Status' }),
                  },
                ]}
                label={<div>Status</div>}
                style={{ marginBottom: errMessageStatusNode ? '0px' : '30px' }}
              >
                <Select onChange={handleSelectStatusNode}>
                  {dataFindOneStatus?.statusDetails?.map((item, key) => {
                    return (
                      <Option key={key} value={item.id}>
                        {item.status}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              {errMessageStatusNode && <p style={{ color: 'red' }}>Status is duplicate</p>}
            </>
          )}
        </Card>,
        '0',
      ),
    ]),
    getItem('Assignee', 'sub1', <UserAddOutlined />, [
      getItem(
        <Card style={{ marginBottom: '30px' }}>
          <CustomFormItem name="listDepartment" label={`Department`}>
            <ITVSelectDepartment
              dataSource={dataDepartment.data}
              placeholder={`Select department`}
              width={280}
              filterOption={(input, option) => {
                return removeAccents(
                  (option!.children! as any)!.props?.children?.props?.children?.props
                    ?.children as unknown as string,
                )
                  ?.toLowerCase()
                  ?.includes(removeAccents(input)?.toLowerCase());
              }}
              valueSelected={form.getFieldValue('listDepartment')}
              onChangeSelect={async (departmentId: any) => {
                handleSelectDepartment(departmentId);
              }}
            />
          </CustomFormItem>
          <CustomFormItem name="employeeId" label={`Employee`} shouldUpdate>
            <ITVSelect
              dataSource={employeeList}
              placeholder={`Select employee`}
              width={280}
              filterOption={(input, option) => {
                return removeAccents(
                  (option!.children! as any)!.props.children[1].props.children[0].props
                    .children as unknown as string,
                )
                  .toLowerCase()
                  .includes(removeAccents(input).toLowerCase());
              }}
              valueSelected={form.getFieldValue('employeeId')}
              onChangeSelect={async (employeeId: string) => {
                dispatch(getEmployeeDetail({ idItem: employeeId }));
                form.setFieldsValue({ employeeId });
              }}
            />
          </CustomFormItem>
          <div
            style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '2%' }}
          >
            <Popconfirm
              title={`Are you sure`}
              onConfirm={() => {
                onAddEmployee();
              }}
              okText={`Yes`}
              cancelText={`No`}
            >
              <CustomButton>{`Add`}</CustomButton>
            </Popconfirm>
          </div>
          <Form.Item
            name={'listEmployee'}
            rules={[
              {
                required: true,
                message: t('HRM_VAD_REQUIRED', { field: 'Employee' }),
              },
            ]}
          >
            <div
              id="scrollableDiv"
              style={{
                height: 200,
                overflowY: 'auto',
                overflowX: 'hidden',
                padding: '0 16px',
                border: '1px solid rgba(140, 140, 140, 0.35)',
                marginTop: '10px',
              }}
            >
              <InfiniteScroll
                dataLength={dataSelecListEmployee?.length}
                next={loadMoreData}
                hasMore={dataSelecListEmployee?.length < 2}
              >
                <List
                  dataSource={dataSelecListEmployee}
                  renderItem={(item) => (
                    <List.Item key={item.email}>
                      <EmployeeColumn
                        id={item?.id}
                        avatar={item?.fullName}
                        fullName={item?.fullName}
                        email={item?.email}
                        minWidth={'0px'}
                        onDelete={onDeleteEmployee}
                        form={form}
                        dataSelecListEmployee={dataSelecListEmployee}
                        setDataSelecListEmployee={setDataSelecListEmployee}
                        record={item}
                      />
                    </List.Item>
                  )}
                />
              </InfiniteScroll>
            </div>
          </Form.Item>
        </Card>,
        '1',
      ),
    ]),
    getItem('View Transition', 'sub2', <ColumnWidthOutlined />, [
      getItem(
        <div>
          {edgenextValueNode?.map((item: any, idx: any) => {
            const valueNext = nodes.find((itemNode: any) => {
              return itemNode.id === item.target;
            });

            return (
              <CustomCard>
                <CustomTag color="green">{valueNode?.data?.label}</CustomTag>
                <ArrowRightOutlined />{' '}
                <CustomTag color="purple">{valueNext?.data?.label}</CustomTag>
                <CustomFormItem name="selectNextAction">
                  <Select defaultValue={item.label} disabled>
                    {initialEdges?.map((item: any) => {
                      return <Option value={item?.label}>{item?.label}</Option>;
                    })}
                  </Select>
                </CustomFormItem>
              </CustomCard>
            );
          })}
          {edgePrevValueNode?.map((itemEdge: any, idx: any) => {
            const valuePrev = nodes.find((itemNode: any) => {
              return itemNode.id === itemEdge.source;
            });

            return (
              <CustomCard>
                <CustomTag color="purple">{valuePrev?.data?.label}</CustomTag>
                <ArrowRightOutlined />
                <CustomTag color="green">{valueNode?.data?.label}</CustomTag>
                <CustomFormItem name="selectPrevAction">
                  <Select disabled defaultValue={itemEdge.label}>
                    {initialEdges?.map((item: any) => {
                      return <Option value={item?.label}>{item?.label}</Option>;
                    })}
                  </Select>
                </CustomFormItem>
              </CustomCard>
            );
          })}
        </div>,
        '2',
      ),
    ]),
  ];

  const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
    setOpenKeys(keys);
  };
  const onClick: MenuProps['onClick'] = (e) => {};
  return (
    <Form form={form} layout="vertical">
      <CustomMenu
        onClick={onClick}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        mode="inline"
        items={items}
      />
    </Form>
  );
};

export default ModalNode;
